import { isNumber } from 'lodash';
import React, { useCallback } from 'react';

import { MOBILE_BREAK_POINT } from 'app/constants';
import useIsMobile from 'hooks/use-is-mobile';

import useStyles from './styles';

interface Props {
    title?: string;
    description?: string;
    credits?: string | number;
    classes?: {
        root?: string;
        item?: string;
        title?: string;
        description?: string;
        credits?: string;
    };
    className?: string;
}

const EstimationItem: React.FC<Props> = ({ title, description, credits, classes, className }) => {
    const { classes: internalClasses, cx } = useStyles();
    const isMobile = useIsMobile(MOBILE_BREAK_POINT);

    const formatCredits = useCallback(
        (credits: string | number | undefined) => {
            if (isMobile && isNumber(credits)) {
                return credits === 1 ? '1 API credit' : `${credits} API credits`;
            }
            return credits;
        },
        [isMobile]
    );

    return (
        <div className={cx(internalClasses.root, classes?.root, className)}>
            <div className={cx(internalClasses.item, internalClasses.title, classes?.item, classes?.title)}>
                {title}
            </div>
            <div className={cx(internalClasses.item, internalClasses.description, classes?.item, classes?.description)}>
                {description}
            </div>
            <div className={cx(internalClasses.item, internalClasses.credits, classes?.item, classes?.credits)}>
                {formatCredits(credits)}
            </div>
        </div>
    );
};

export default EstimationItem;
